import * as React from 'react';

export interface NlToListProps {
    text?: string
    itemProp?: string
}

export class NlToList extends React.Component<NlToListProps> {
    public render() {
        const props = this.props;
        const lines = this.getLines();

        return <ul itemProp={props.itemProp}>{lines.map((line, index) => <li key={line + index}>{line}</li>)}</ul>;
    }

    private getLines(): string[] {
        const text = this.getText();

        if (text !== '') {
            return text.split('\n');
        } else {
            return [];
        }
    }

    private getText(): string {
        const props = this.props;
        const children = props.children;
        if (props.text) {
            return props.text.trim();
        } else if (typeof children === 'string') {
            return children.trim();
        } else {
            console.error('Children are not of type string');

            return '';
        }
    }
}
